import React from 'react';
import { 
  Whatsapp, 
  TelephoneFill, 
  Instagram, 
  Tiktok, 
  Youtube, 
    TwitterX 
} from 'react-bootstrap-icons';
import './FloatingSocialBar.css';

const FloatingSocialBar = () => {
const socialLinks = [
    {
      id: 'whatsapp',
      title: 'واتساب',
      icon: <Whatsapp size={20} />,
      url: 'https://wa.me/966504480025',
      bg: '#25d366'
    },
    {
      id: 'phone',
      title: 'اتصال مباشر',
      icon: <TelephoneFill size={18} />,
      url: 'tel:+966504480025',
      bg: '#007bff'
    },
    {
      id: 'instagram',
      title: 'إنستغرام',
      icon: <Instagram size={19} />,
      url: 'https://instagram.com/Aamalalmasbah',
      bg: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)'
    },
    {
      id: 'youtube',
      title: 'يوتيوب',
      icon: <Youtube size={20} />,
      url: 'https://youtube.com/@aamalalmasbah',
      bg: '#ff0000'
    },
    {
      id: 'tiktok',
      title: 'تيك توك',
      icon: <Tiktok size={19} />,
      url: 'https://tiktok.com/@aamalalmasbah',
      bg: '#010101' // 👈 تدرج نيون متناسق يبرز أيكونة التيك توك
    },
    {
      id: 'x',
      title: 'إكس (تويتر)',
      icon: <TwitterX size={18} />,
      url: 'https://x.com/aamalalmasbah',
      bg: '#1da1f2' // 👈 الأزرق المبهج يكسر غتمة الأسود ويفصل الزرار الأخير
    },
  ];

  return (
    <div className="floating-social-sidebar" id="floating-social-sidebar">
      {socialLinks.map((item) => (
        <a
          key={item.id}
          href={item.url}
          target="_blank"
          rel="noopener noreferrer"
          className="social-floating-btn"
          style={{ 
            background: item.bg,
            color: item.color || '#ffffff'
          }}
        >
          <span className="social-icon">{item.icon}</span>
          <span className="social-label">{item.title}</span>
        </a>
      ))}
    </div>
  );
};

export default FloatingSocialBar;